import { createPivotTransformer } from './create-pivot-transformer';

const JOULES_PER_KWH = 3.6e6;
const JOULES_PER_MWH = 3.6e9;

/** Pivot = J. Real energy only — not interchangeable with apparent/reactive energy. */
export const ENERGY_PIVOT: Record<string, number> = {
  j: 1,
  kj: 1000,
  mj: 1e6,
  wh: 3600,
  kwh: JOULES_PER_KWH,
  mwh: JOULES_PER_MWH,
  gwh: 3.6e12,
  twh: 3.6e15,
  btu: 1055.06,
  mmbtu: 1.05506e9,
  cal: 4.184,
  kcal: 4184,
  therm: 1.05506e8,
};

/** Pivot = kVAh. Apparent energy — not interchangeable with real or reactive energy. */
export const APPARENT_ENERGY_PIVOT: Record<string, number> = {
  kvah: 1,
  mvah: 1000,
};

/** Pivot = kVARh. Reactive energy — not interchangeable with real or apparent energy. */
export const REACTIVE_ENERGY_PIVOT: Record<string, number> = {
  kvarh: 1,
  mvarh: 1000,
};

export const transformEnergy = createPivotTransformer(ENERGY_PIVOT);
export const transformApparentEnergy = createPivotTransformer(APPARENT_ENERGY_PIVOT);
export const transformReactiveEnergy = createPivotTransformer(REACTIVE_ENERGY_PIVOT);
